import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus, Heart, ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/site";

export const RoleGate = () => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [starter, setStarter] = useState({ claimed: 0, total: 10, remaining: 10 });

  useEffect(() => {
    if (!localStorage.getItem("ff_role")) setOpen(true);
    api.get("/starter/status").then((r) => setStarter(r.data)).catch(() => {});
  }, []);

  const pick = (role) => {
    localStorage.setItem("ff_role", role);
    setOpen(false);
    if (role === "creator") nav("/for-creators");
    else nav("/discover");
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-[#0a0612]/95 backdrop-blur-xl grid place-items-center px-6" data-testid="role-gate">
      <div className="max-w-3xl w-full text-center">
        <div className="inline-flex items-center gap-2 border border-white/15 bg-white/5 rounded-full px-4 py-1.5 mb-6">
          <Sparkles size={14} className="text-brand" />
          <span className="text-xs font-medium text-white/80">Welcome to Fan Focus</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl text-white leading-[1.05]">
          Are you a <span className="text-brand">Creator</span><br />or a <span className="text-brand">Fan?</span>
        </h1>
        <p className="mt-5 text-white/60 text-lg">Pick your experience to continue.</p>

        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          <button onClick={() => pick("creator")} data-testid="gate-creator"
            className="card p-8 text-left hover:-translate-y-1 hover:border-pink-500/50 transition-all">
            <div className="flex items-center gap-3 mb-3">
              <div className="h-11 w-11 rounded-full bg-pink-500/15 grid place-items-center"><UserPlus className="text-brand" size={20} /></div>
              <h3 className="font-display text-2xl text-brand">I'm a Creator</h3>
            </div>
            <p className="text-white/65 text-sm mb-4">Access services, plans, network, dashboard, analytics, and AutoPilot tools.</p>
            <span className="inline-flex items-center gap-2 text-brand font-semibold text-sm">Continue as Creator <ArrowRight size={15} /></span>
            {starter.remaining > 0 && (
              <div className="mt-5 text-xs text-white/70 border border-brand/30 bg-pink-500/10 rounded-lg px-3 py-2">
                🎁 <span className="text-brand font-semibold">Starter Token</span> — {starter.remaining} of {starter.total} left. First 10 creators get <b>90 days free</b>.
              </div>
            )}
          </button>

          <button onClick={() => pick("fan")} data-testid="gate-fan"
            className="card p-8 text-left hover:-translate-y-1 hover:border-violet-500/50 transition-all">
            <div className="flex items-center gap-3 mb-3">
              <div className="h-11 w-11 rounded-full bg-violet-500/15 grid place-items-center"><Heart className="text-violet-300" size={20} /></div>
              <h3 className="font-display text-2xl text-violet-300">I'm a Fan</h3>
            </div>
            <p className="text-white/65 text-sm mb-4">Preview creators, browse content, follow favorites, and support who you love.</p>
            <span className="inline-flex items-center gap-2 text-violet-300 font-semibold text-sm">Continue as Fan <ArrowRight size={15} /></span>
            <div className="mt-5 text-xs text-white/50 border border-white/10 rounded-lg px-3 py-2">Free forever · No credit card</div>
          </button>
        </div>
      </div>
    </div>
  );
};
